import formatQueryString from '../../../../utils/formatQueryString';

export default (params): string => `/hp/api/feed-items?${formatQueryString(params)}`;
